import styled from "styled-components";

import { rgba } from "polished";

import ChevronUpIcon from "../../../assets/images/chevron-up.svg";
import ChevronDownIcon from "../../../assets/images/chevron-down.svg";
import ChevronUpWhiteIcon from "../../../assets/images/chevron-up-white.svg";
import ChevronDownWhiteIcon from "../../../assets/images/chevron-down-white.svg";

export const Table1 = styled.table`
    width: 100%;

    border-collapse: collapse;

    border-radius: 8px;
    overflow: hidden;

    thead {
        tr {
            &:not(:first-child) {
                th {
                    border-radius: 0 !important;
                }
            }

            th {
                background: ${(props) => rgba(props.theme.orange, 0.25)};
                color: ${(props) => rgba(props.theme.black, 0.8)};
                vertical-align: middle;
                border: none !important;

                white-space: nowrap;

                padding: 12px;

                text-align: left;

                &.has-sort {
                    span {
                        display: block;
                        width: 100%;
                        position: relative;
                        border: none;
                        cursor: pointer;
                        padding-right: 16px;

                        &::before {
                            content: "";
                            width: 10px;
                            height: 10px;

                            position: absolute;
                            top: calc(50% - 10px);
                            right: 0;

                            background-image: url(${(props) =>
                                props.theme.theme === "light" ? ChevronUpIcon : ChevronUpWhiteIcon});
                            background-size: cover;
                            background-position: center;
                            background-repeat: no-repeat;

                            transition: 0.2s all ease-in-out;
                            opacity: 0.4;
                        }

                        &::after {
                            content: "";
                            width: 10px;
                            height: 10px;

                            position: absolute;
                            top: calc(50% + 2px);
                            right: 0;

                            background-image: url(${(props) =>
                                props.theme.theme === "light" ? ChevronDownIcon : ChevronDownWhiteIcon});
                            background-size: cover;
                            background-position: center;
                            background-repeat: no-repeat;

                            transition: 0.2s all ease-in-out;
                            opacity: 0.4;
                        }
                    }
                    &.asc {
                        span {
                            &::before {
                                opacity: 1;
                            }
                        }
                    }
                    &.desc {
                        span {
                            &::after {
                                opacity: 1;
                            }
                        }
                    }
                }
            }
        }
    }

    tbody {
        tr {
            td {
                background: ${(props) => props.theme.white};
                color: ${(props) => rgba(props.theme.black, 0.7)};
                vertical-align: middle;
                border-bottom: 1px ${(props) => rgba(props.theme.black, 0.1)} solid;

                padding: 12px;

                text-align: left;

                .actions {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    white-space: nowrap;
                }
            }

            &.action-tr {
                td {
                    padding-top: 0;
                }
            }

            &:last-child {
                td {
                    border-bottom: none;
                }
            }
        }
    }

    &:not(.with-action-tr) {
        tbody {
            tr {
                &:nth-child(even) {
                    td {
                        background: ${(props) => props.theme.gray100};
                    }
                }
            }
        }
    }

    &.with-action-tr {
        tbody {
            tr {
                &.odd {
                    td {
                        background: ${(props) => props.theme.gray100};
                    }
                }
            }
        }
    }

    &.with-border {
        tbody {
            tr {
                td {
                    border-right: 1px ${(props) => rgba(props.theme.black, 0.1)} solid;
                }
            }
        }
    }
`;
